module.exports = __webpack_public_path__ + "static/media/RedtagMobo.f76f5b7e.png";